<template>
    
    <div>
        <myHead/>
        <div style="padding:20px">
            <a-row  style="width:100%; ">
                <a-col flex="600px">
                    <a-card >
                        <h3><WalletOutlined /> 钱包</h3>
                         <a-divider  />
                         <div style="height:156px">
                            <a-row >
                                <a-col :span="12">
                                    <a-statistic title="现金账户" :precision="2" :value="memberAccount.Balance" />
                                </a-col>
                                <a-col :span="12">
                                    <a-statistic title="赔付账户" :precision="2" :value="memberAccount.Payout" />
                                </a-col>
                            </a-row>
                            <div v-if="memberAccount.Advance>0" style="letter-spacing:1px;line-height:25px;">
                                <div style="font-size:12px;">平台已为您开通 
                                    <span style="color:#F56C6C">{{(memberAccount.Advance).toFixed(2)}}</span> 元垫付额度</div>
                                <div style="font-size:12px;" >垫付额度代表您账户最大可透支金额，使用垫付额度须在次日返款</div>
                            </div>
                            <div v-else style="line-height:50px;opacity:0">
                                .
                            </div>
                            <a-row :gutter="30" style="margin-top:-15px">
                                <a-col :span="12">
                                    <a-button @click="topUpAction" class="loginBtn" >
                                        充值
                                    </a-button>
                                </a-col>
                                <a-col :span="12">
                                    <a-button  @click="withdrawAction"  class="otherBtn" >
                                    提现
                                </a-button>
                                </a-col>
                            </a-row>
                        </div>
                    </a-card>
                </a-col>
                <a-col flex="auto" style="margin-left:20px"  >
                    <a-card style="">
                        <h3> <BarChartOutlined /> 消费概览</h3>
                         <a-divider  />
                             <div id="myChart" :style="'width: '+dataWidth+'px; height: 156px;'">
                            </div>
                    </a-card>
                </a-col>
            </a-row>
            <a-row style="padding-top:30px" >
                <a-col :span="24">
                     <a-card style="width:100%">
                        <a-tabs v-model:activeKey="activeKey" tab-position="left" style="width:100%">
                            <a-tab-pane key="1"  >
                                <template #tab>
                                    <span>
                                    <PayCircleOutlined />
                                     充值记录
                                    </span>
                                </template>
                                 <a-table 
                                    :rowKey="record => record.Id" 
                                    :columns="columns"  
                                    :loading="isLoading"
                                    :data-source="topUpList"
                                    @change="handleTableChange"
                                    :pagination="pagination">
                                    <template #status="{ text: Status }">
                                        <span>
                                            <a-tag v-if="Status==3" color="#F56C6C">失败</a-tag>
                                            <a-tag v-else-if="Status==1" color="#E6A23C">审核中</a-tag>
                                            <a-tag v-else color="#67C23A">成功</a-tag>
                                        </span>
                                    </template>
                                    <template #moneyText="{ text }">
                                        <span style="font-weight:500">
                                            ￥{{text}}
                                        </span>
                                    </template>
                                    <template #transferor="{ text,record  }">
                                        <span>
 
                                            <a @click="preview(record)"> <PictureOutlined /> {{text}}</a>
                                        </span>
                                    </template>
                                </a-table>
                            </a-tab-pane>
                            <a-tab-pane key="2" >
                                <template #tab>
                                    <span>
                                    <TransactionOutlined />
                                     提现记录
                                    </span>
                                </template>
                                 <a-table 
                                    :rowKey="record => record.Id" 
                                    :columns="columnsWithdraw"  
                                    :loading="isLoading"
                                    :data-source="withdrawList"
                                    @change="handleTableChangeWithdraw"
                                    :pagination="paginationWithdraw">
                                    <template #moneyText="{ text }">
                                        <span style="font-weight:500">
                                            ￥{{text}}
                                        </span>
                                    </template>
                                    <template #status="{ text: Status }">
                                        <span>
                                            <a-tag v-if="Status==3" color="#F56C6C">失败</a-tag>
                                            <a-tag v-else-if="Status==1" color="#E6A23C">审核中</a-tag>
                                            <a-tag v-else color="#67C23A">成功</a-tag>
                                        </span>
                                    </template>
                                </a-table>
                            </a-tab-pane>
                        </a-tabs>
                    </a-card>
                </a-col>
            </a-row>
        </div>
         <myFooter/>
         <myPreview   v-model:show="isPreview" :src="imgSrc" />

    <a-drawer
    title="充值"
    :width="720"
    :visible="topUpVisible"
    :body-style="{ paddingBottom: '80px' }"
    @close="topUpVisible=false"
  >
    <a-form :model="topUpForm" ref="topUpRef" :rules="topUpRules" layout="vertical">
        <a-row :gutter="16">
            <a-col :span="12">
                <a-form-item :label="rechargeTab.activeKey==1||rechargeTab.activeKey==2?'账号名称':'开户名' " name="Transferor">
                    <a-input v-model:value="topUpForm.Transferor" :placeholder="rechargeTab.activeKey==1||rechargeTab.activeKey==2?'请输入账号名称':'请输入开户名'"/>
                </a-form-item>
            </a-col>
            <a-col :span="12">
            <a-form-item label="充值金额" name="Money">
                        <a-input-number
                        :min="1"
                        style="width:100%"
                        v-model:value="topUpForm.Money"
                        :formatter="value => `￥${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\￥\s?|(,*)/g, '')"/>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16">
            <a-col :span="24">
                <a-form-item label="转账凭证" name="ImgSrc">
                    <a-upload
                     accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                            name="avatar"
                            list-type="picture-card"
                            class="avatar-uploader"
                            :show-upload-list="false"
                            :action="baseUrl+'/Account/PushImg'"
                            @change="handleChange"
                        >
                            <img style="width:102px;height:102px" v-if="topUpForm.ImgSrc" :src="topUpForm.ImgSrc" alt="avatar" />
                            <div v-else>
                            <a-spin v-if="uploading"/>
                            <plus-outlined v-else>
                                <PlusOutlined   />
                            </plus-outlined> 
                            </div>
                        </a-upload>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16" style="margin-top:-10px">
            <a-col :span="24" >
                    <a-tabs v-model:activeKey="rechargeTab.activeKey">
                                <a-tab-pane key="1" v-if="memberAccount.Alipay">
                                    <template #tab>
                                        <span>
                                        <AlipayOutlined />
                                        支付宝
                                        </span>
                                    </template>
                                    <a-alert style="font-size:13px" message="请仔细核对收款方信息是否正确" type="info" show-icon />

                                    <a-descriptions title="" style="margin-top:10px" layout="vertical" bordered>
                                        <a-descriptions-item label="名称">
                                            {{memberAccount.Alipay.AccountName}}
                                        </a-descriptions-item>
                                        <a-descriptions-item label="账号">
                                            {{memberAccount.Alipay.Account}}
                                        </a-descriptions-item>
                                        <a-descriptions-item label="收款码">
                                            <a-image style="width:200px" :src="memberAccount.Alipay.CollectionCode"/>
                                        </a-descriptions-item>
                                    </a-descriptions>
                                </a-tab-pane>
                                <a-tab-pane key="2" v-if="memberAccount.Wechat">
                                    <template #tab>
                                        <span>
                                        <WechatOutlined />
                                        微信
                                        </span>
                                    </template>
                                    <a-alert style="font-size:13px" message="请仔细核对收款方信息是否正确" type="info" show-icon />
                                    <a-descriptions title="" style="margin-top:10px" layout="vertical" bordered>
                                        <a-descriptions-item label="名称">
                                            {{memberAccount.Wechat.AccountName}}
                                        </a-descriptions-item>
                                        <a-descriptions-item label="账号">
                                            {{memberAccount.Wechat.Account}}
                                        </a-descriptions-item>
                                        <a-descriptions-item label="收款码">
                                            <a-image style="width:200px" :src="memberAccount.Wechat.CollectionCode"/>
                                        </a-descriptions-item>
                                    </a-descriptions>

                                </a-tab-pane>
                                
                                <a-tab-pane key="3" v-if="memberAccount.Payment">
                                    <template #tab >
                                        <span>
                                        <CreditCardOutlined />
                                        网上银行
                                        </span>
                                    </template>
                                    <a-alert style="font-size:13px" message="请仔细核对收款方信息是否正确" type="info" show-icon />
                                    
                                    <a-descriptions title="" style="margin-top:10px" layout="vertical" bordered>
                                        <a-descriptions-item label="名称">
                                            {{memberAccount.Payment.AccountName}}
                                        </a-descriptions-item>
                                        <a-descriptions-item label="开户行">
                                            {{memberAccount.Payment.AccountBankName}}
                                        </a-descriptions-item>
                                        <a-descriptions-item label="卡号">
                                            {{memberAccount.Payment.CardNo}}
                                        </a-descriptions-item>
                                    </a-descriptions>
                                </a-tab-pane>
                            </a-tabs>
            </a-col>

        </a-row>
    </a-form>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 8px" @click="topUpVisible=false">取消</a-button>
      <a-button type="primary" @click="topUpSumbit">确定</a-button>
    </div>
  </a-drawer>


    <a-drawer
    title="提现"
    :width="720"
    :visible="withdrawVisible"
    :body-style="{ paddingBottom: '80px' }"
    @close="withdrawVisible=false"
  >
    <a-form :model="withdrawForm" ref="withdrawRef" :rules="withdrawRules" layout="vertical">
        <a-row :gutter="16">
            <a-col :span="12">
                <a-form-item label="开户名" name="AccountName">
                    <a-input v-model:value="withdrawForm.AccountName" placeholder="请输入开户名"/>
                </a-form-item>
            </a-col>
            <a-col :span="12">
            <a-form-item label="提现金额" name="Money">
                        <a-input-number
                        :min="1"
                        style="width:100%"
                        v-model:value="withdrawForm.Money"
                        :formatter="value => `￥${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\￥\s?|(,*)/g, '')"/>
            </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16">
            <a-col :span="12">
                <a-form-item label="银行名称" name="AccountBankName">
                    <a-input v-model:value="withdrawForm.AccountBankName" placeholder="请输入银行名称"/>
                </a-form-item>
            </a-col>
            <a-col :span="12">
            <a-form-item label="银行卡号" name="CardNo">
                    <a-input v-model:value="withdrawForm.CardNo" placeholder="请输入银行卡号"/>
            </a-form-item>
            </a-col>
        </a-row>
    </a-form>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 8px" @click="withdrawVisible=false">取消</a-button>
      <a-button type="primary" @click="withdrawSumbit">确定</a-button>
    </div>
  </a-drawer>
    </div>
</template>
<script>
import myHead from '../components/myHead'
import myFooter from '../components/myFooter'
 import myPreview from '../components/myPreview'

import {accountGetAccount,accountGetCommission,topUpGet,withdrawGet,topUp,withdrawNew,uri} from '@/request.js'


import { message } from 'ant-design-vue';
// AlipayOutlined,WechatOutlined,CreditCardOutlined
import { WalletOutlined,PayCircleOutlined,BarChartOutlined,TransactionOutlined,PictureOutlined,WechatOutlined,
AlipayOutlined,CreditCardOutlined,PlusOutlined} from '@ant-design/icons-vue';

export default {
    components:{ myHead,myFooter,WalletOutlined,PayCircleOutlined,BarChartOutlined,
    TransactionOutlined,PictureOutlined,myPreview,WechatOutlined,AlipayOutlined,CreditCardOutlined,PlusOutlined},
    data(){
        return{
            dataWidth:0,
            withdrawVisible:false,
            uploading:false,
            baseUrl:uri,
            topUpType:1,
            topUpVisible:false,
            isPreview:false,
            isLoading:false,
            imgSrc:"",
            memberAccount:{},
            activeKey: '1',
            rechargeTab:{
                activeKey:"1",
            },
            commissionData: {},
            topUpTotal:0,
            topUpList:[],
            withdrawList:[],
            columns:[
                {
                    title: '提交时间',
                    dataIndex: 'CreateTime',
                    key: 'CreateTime',
                },
                {
                    title: '金额',
                    dataIndex: 'MoneyText',
                    key: 'MoneyText',
                    slots: { customRender: 'moneyText' },
                },
                {
                    title: '转账凭证',
                    dataIndex: 'Transferor',
                    key: 'Transferor',
                    slots: { customRender: 'transferor' },
                },
                {
                    title: '状态',
                    dataIndex: 'Status',
                    key: 'Status',
                    slots: { customRender: 'status' },
                },
                
            ],
            columnsWithdraw:[
                {
                    title: '提交时间',
                    dataIndex: 'CreateTime',
                    key: 'CreateTime',
                },
                {
                    title: '开户名',
                    dataIndex: 'AccountName',
                    key: 'AccountName',
                },
                {
                    title: '开户行',
                    dataIndex: 'AccountBankName',
                    key: 'AccountBankName',
                },
                                {
                    title: '卡号',
                    dataIndex: 'CardNo',
                    key: 'CardNo',
                },
                {
                    title: '金额',
                    dataIndex: 'MoneyText',
                    key: 'MoneyText',
                    slots: { customRender: 'moneyText' },
                },
                {
                    title: '状态',
                    dataIndex: 'Status',
                    key: 'Status',
                    slots: { customRender: 'status' },
                },
            ],
            pagination: {
                total: 0,
                pageSize: 5,//每页中显示10条数据
                showSizeChanger: false,
                pageSizeOptions: ["5", "10", "20", "50"],//每页中显示的数据
                showTotal: total => `共 ${total} 条`,  //分页中显示总的数据
            },
            paginationWithdraw: {
                total: 0,
                pageSize: 5,//每页中显示10条数据
                showSizeChanger: false,
                pageSizeOptions: ["5", "10", "20", "50"],//每页中显示的数据
                showTotal: total => `共 ${total} 条`,  //分页中显示总的数据
            },
            topUpForm:{
                Transferor:"",
                Money:1,
                ImgSrc:"",
            },
            topUpRules:{
                Transferor:[{required:true,message:'请填写账号名称/开户名'}],
                Money:[{required:true,message:'请填写充值金额',type:'number'}],
                ImgSrc:[{required:true,message:'请上传转账凭证截图'}],
            },
            withdrawForm:{
                Money:0,
                AccountBankName:"",
                AccountName:"",
                CardNo:"",
            },
            withdrawRules:{
                AccountBankName:[{required:true,message:'请填写银行名称'}],
                Money:[{required:true,message:'请填写充值金额',type:'number'}],
                AccountName:[{required:true,message:'请填写银行卡开户名'}],
                CardNo:[{required:true,message:'请填写银行卡卡号'}],
            }
        }
    },
    created(){
        accountGetAccount({},(res)=>{
            this.memberAccount=res.Result;
        })
        this.dataWidth=document.body.clientWidth-720;
    },
    mounted(){
        if(this.$route.query.topUpVisible){
            this.topUpVisible=true;
        }
        let myChart = this.$root.echarts.init(
            document.getElementById("myChart")
        );
        accountGetCommission({},(res)=>{
             myChart.setOption(res.Result);
        });
        this.topUpGetAction(1);
         this.withdrawGetAction(1);
    },
    methods:{
        withdrawSumbit(){
            this.$refs.withdrawRef
            .validate()
            .then(() => {
                    withdrawNew(this.withdrawForm,(res)=>{
                        if(res.IsSuccess){
                           this.withdrawGetAction(1);
                           this.withdrawVisible=false;
                            message.success("提交成功，请等待审核");
                        }else{
                            message.error(res.Message);
                        }
                    })
            })
            .catch(error => {
                 console.log('error', error);
            });
        },
        withdrawAction(){
            this.withdrawForm={
                Money:0,
                AccountBankName:"",
                AccountName:"",
                CardNo:"",
            }
            this.withdrawVisible=true;

        },
        topUpAction(){
            this.topUpForm={
                Transferor:"",
                Money:1,
                ImgSrc:"",
            }
            this.topUpVisible=true;
        },
        topUpSumbit(){
            this.$refs.topUpRef
            .validate()
            .then(() => {
                    topUp(this.topUpForm,(res)=>{
                        if(res.IsSuccess){
                           this.topUpGetAction(1);
                           this.topUpVisible=false;
                            message.success("提交成功，请等待审核");
                        }else{
                            message.error(res.Message);
                        }
                    })
            })
            .catch(error => {
                 console.log('error', error);
            });
        },
        preview(record){
            this.imgSrc=record.ImgUrl;
            this.isPreview=true;
        },
        withdrawGetAction(pageIndex){
            this.isLoading=true;
            withdrawGet({pIndex:pageIndex,pSize:this.pagination.pageSize},(res)=>{
                this.withdrawList=res.Result;
                this.paginationWithdraw.total=res.TotalCount;
                this.isLoading=false;
            })
        },
        topUpGetAction(pageIndex){
            this.isLoading=true;
            topUpGet({pIndex:pageIndex,pSize:this.pagination.pageSize},(res)=>{
                this.topUpList=res.Result;
                this.pagination.total=res.TotalCount;
                this.isLoading=false;
            })
        },
        handleTableChange(e){
            this.topUpGetAction(e.current)
        },
        handleTableChangeWithdraw(e){
            this.withdrawGetAction(e.current);
        },
        handleChange(info){
            if(info.file.status=="uploading"){
                this.uploading=true;
            }else{
                if(info.file.response){
                    var res=info.file.response;
                    if(res.IsSuccess){
                        this.uploading=false;
                        this.topUpForm.ImgSrc= res.Message;
                    }else{
                        message.error(res.Message);
                    }
                }
            }
        },
    }
}
</script>
<style scoped>

</style>